import Lottie from 'react-lottie-player'

// Components
import loadingAnimation from '../../utils/Animations/loadingAnimation'

// Animations

const LoadingSpinner = ({ loadingMessage, width, height }) => (
  <div className='flex flex-col justify-center items-center'>
    <Lottie
      className={`${!height ? 'h-80' : height} ${!width ? 'w-80' : width}`}
      loop
      animationData={loadingAnimation}
      play
    />
    <h1 className='antialiased text-center font-bold text-purple-font text-xl'>
      {loadingMessage}
    </h1>
  </div>
)

export default LoadingSpinner
